module.exports = __webpack_public_path__ + "img/ring_g_o_1_1@3x.45e88a5e.png";